import { IconBrowser } from '@tabler/icons-react';
import clsx from 'clsx';

export function EmptyView({ className }: { className?: string }) {
  return (
    <div
      className={clsx(
        'cornerBorder flex h-full w-full flex-col items-center justify-center gap-0 bg-gray-600',
        className,
      )}
    >
      <IconBrowser
        size={80}
        color="white"
      />
      <span className="text-xl font-bold text-white">No preview</span>
      <span className="mx-1 text-center text-gray-100">Preview is not available for the current step</span>
    </div>
  );
}
